/* import __COLOCATED_TEMPLATE__ from './sync-with-zendesk.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();